import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { blogPosts } from './blog-posts';

@Component({
  selector: 'app-blog',
  imports: [CommonModule, MatCardModule, RouterLink],
  templateUrl: './blog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './blog.component.css'
})
export class BlogComponent {
  posts = blogPosts;
}
